const createSwiper = require('../../../components/swiperFactory');
/**
 * Init swiper slider.
 *
 * @param {Element|string} container - HTMLElement or string (with CSS
 * Selector) of swiper container HTML element. Required.
 * @param {Object} [sliderConfig] - object with Swiper parameters. Optional.
 * @returns {Promise.<Object>} - Swiper instance
 */
async function swiperInit(container, sliderConfig) {
    return createSwiper(container, {
        direction: 'horizontal',
        grabCursor: true,
        mousewheel: false,
        speed: 3000,
        loop: sliderConfig.infiniteScroll || false,
        updateOnWindowResize: true,
        watchOverflow: true,
        scrollbar: sliderConfig.scrollbar
            ? {
                el: '.swiper-scrollbar',
                hide: false
            }
            : false,
        navigation: sliderConfig.navigation
            ? {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
            : false,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            waitForTransition: true,
            reverseDirection: false,
            pauseOnMouseEnter: true
        },

        breakpoints: {
            0: {
                slidesPerView: sliderConfig.slidesNumberMobile || 1.3,
                spaceBetween: sliderConfig.spacing
            },
            768: {
                slidesPerView: sliderConfig.slidesNumberDesktop || 3.1,
                spaceBetween: sliderConfig.spacing
            }
        }
    });
}

/**
 * Get slider config from Data arguments
 *
 * @param {Object} sliderContainer Swiper slider container with slider config
 * @return {Object|null} Slider config
 */
function getSliderConfig(sliderContainer) {
    if (!sliderContainer) {
        return null;
    }
    return {
        slidesNumberDesktop: sliderContainer.dataset.slidesnumberdesktop,
        slidesNumberMobile: sliderContainer.dataset.slidesnumbermobile,
        infiniteScroll: sliderContainer.dataset.infinitescroll,
        spacing: sliderContainer.dataset.spacing,
        scrollbar: sliderContainer.dataset.scrollbar,
        navigation: sliderContainer.dataset.navigation,
        autoplay: sliderContainer.dataset.autoplay,
        scrollAnimation: sliderContainer.dataset.scrollanimation
    };
}

document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll(
        '.pd-adn-live-ended__shows-wrapper'
    );

    sliders.forEach(function (slider) {
        const sliderObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio > 0) {
                        Promise.resolve(
                            swiperInit(
                                entry.target,
                                getSliderConfig(entry.target)
                            )
                        ).then(() => {
                            sliderObserver.unobserve(entry.target);
                        });
                    }
                });
            },
            { threshold: 0 }
        );

        sliderObserver.observe(slider);
    });
});
